'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import { getCRMEmailLoggingSettingsUrl } from '../url/getCRMEmailLoggingSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailAttachmentDisabledBanner = ({
  onClose
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.attachmentDisabledMessage.title"
    }),
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.attachmentDisabledMessage.description_jsx",
      elements: {
        UILink
      },
      options: {
        emailLoggingSettingsURL: getCRMEmailLoggingSettingsUrl()
      }
    })
  });
};
EmailAttachmentDisabledBanner.displayName = 'EmailAttachmentDisabledBanner';
EmailAttachmentDisabledBanner.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default EmailAttachmentDisabledBanner;